import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { ImageIcon } from 'lucide-react'
import type { FlashcardCategory } from '@services/firebase/flashcards'
import { LmsButton } from '@shared/ui'
import './flashcard-category.css'

export function FlashcardCategoryCard({
  category,
  onPrefetch,
  onSelect,
}: {
  readonly category: FlashcardCategory
  readonly onPrefetch: () => void
  readonly onSelect: () => void
}) {
  const ui = useLearningUiTranslation()
  const categoryTitle = category.title ?? category.id

  return (
    <LmsButton
      aria-label={ui('Open {{category}} flashcard category', { category: categoryTitle })}
      className="flashcardCategoryCard"
      onFocus={onPrefetch}
      onClick={onSelect}
      onPointerEnter={onPrefetch}
      type="button"
      variant="ghost"
    >
      {category.featuredImage ? (
        <img
          alt={categoryTitle}
          className="flashcardCategoryCardImage"
          src={category.featuredImage}
        />
      ) : (
        <span aria-hidden="true" className="flashcardCategoryCardPlaceholder">
          <ImageIcon />
        </span>
      )}
      <span className="flashcardCategoryCardBody">
        <span className="flashcardCategoryCardTitle">{categoryTitle}</span>
        <span className="flashcardCategoryCardDescription">
          {ui("Open this flashcard category to curate cards, start a slideshow, or launch a game session.")}</span>
      </span>
    </LmsButton>
  )
}
